<template>
  <div class="leave-message">
    <z-fix-top
      v-if="showSelfHeader"
      ref="fixTopHeader"
      keep-position
    >
      <z-nav-bar class="z-nav-bar__v9">
        <div slot="left" class="left-wrapper">
          <z-icon class="icon-back" class-prefix="zziconfont-5" name="back" @click="handleGoBack" />
        </div>
        <div slot="title" class="title-wrapper">
          <span class="title-text">留言</span>
        </div>
      </z-nav-bar>
    </z-fix-top>
    <div class="leave-message-msg-text">
      <textarea
        ref="textInput"
        type="text"
        v-model="msgTxt"
        placeholder="请您简述清楚您的问题哦～"
        rows="1"
        @blur="txtBoxBlur"
        @input="updateTextInfo"
      ></textarea>
      <div class="leave-message-msg-text-num-wrap">
        <p class="leave-message-msg-text-num">
          <span :class="{ red: msgTxt.length >= maxNum }">{{ msgTxt.length }}</span
          >/{{ maxNum }}
        </p>
      </div>
      <div class="leave-message-upload-area">
        <z-upload
          v-model="files"
          ref="upload"
          :process-file="processFile"
          :accept="accept"
          :max="max"
          :zzapp="zzapp"
          :zlj="zljapp"
          :zzhunter="zzhunter"
          btnUploadInfo="添加照片"
        >
        </z-upload>
      </div>
    </div>
    <z-button-group>
      <z-button @click="backToPrePage">取消</z-button>
      <z-button @click="confirmSubmit" type="primary">确认</z-button>
    </z-button-group>
  </div>
</template>

<script>
import native from '@zz-common/native-adapter'
import { lego } from '@zz-common/lego'
import { Button, ButtonGroup, Upload, FixTop, NavBar, Icon } from '@zz-common/zz-ui'
import { url } from '@zz-common/zz-utils'
import compress from '@zz-common/zz-ui/lib/utils/image'
import { userLeavingMessage } from '../../../api/resourceApi'
import { getCookie } from '../../../lib/utils'
import { toast } from '../../../native'

const MAX_INPUT_NUM = 200

export default {
  name: 'LeaveMessage',
  components: {
    'z-button-group': ButtonGroup,
    'z-button': Button,
    'z-upload': Upload,
    'z-fix-top': FixTop,
    'z-nav-bar': NavBar,
    'z-icon': Icon
  },
  data() {
    return {
      msgTxt: '',
      maxNum: MAX_INPUT_NUM,
      // action: { target: 'https://upload.58cdn.com.cn/json?rand=0.1928', zz: true },
      accept: 'image/*',
      max: 9,
      zzapp: true,
      zljapp: true, // 兼容找靓机端内上传
      zzhunter: true,
      files: [],
      showSelfHeader: true, // 是否展示自定义头部，小程序隐藏
      urlParams: {}
    }
  },
  mounted() {
    this.urlParams = url.getParams()
    // 微信小程序下不展示自定义头部
    if (native.in('wa')) {
      this.showSelfHeader = false
    }
  },
  created() {
    native.setTitle({
      title: '留言'
    })
  },
  computed: {
    showBtn() {
      return this.max > this.files.length
    }
  },
  methods: {
    // 头部返回按钮
    handleGoBack() {
      const { appType, orderId, subConvId, ticketId, sourceType } = this.urlParams
      if (subConvId && ticketId) { // 有子会话id表示从IM进入，则需要记录返回
        lego.send({
          pagetype: 'KEFUIM_HOME',
          actiontype: 'GOBACK_LEAVE_MSG',
          backup: {
            appType,
            orderId,
            subConvId,
            ticketId,
            sourceType,
            sendTime: new Date().getTime(),
            uid: native.getUid()
          }
        })
      }
      native.close()
    },
    processFile(file, next) {
      compress(
        file,
        {
          compress: true // 开启图片压缩，提高上传的速度，同时修正拍摄的图片方向和显示的问题
        },
        next
      )
    },
    // 点击取消按钮
    backToPrePage() {
      const { appType, orderId, subConvId, ticketId, sourceType } = this.urlParams
      if (subConvId && ticketId) { // 有子会话id表示从IM进入，则需要记录返回
        lego.send({
          pagetype: 'KEFUIM_HOME',
          actiontype: 'CANCEL_LEAVE_MSG',
          backup: {
            appType,
            orderId,
            subConvId,
            ticketId,
            sourceType,
            sendTime: new Date().getTime(),
            uid: native.getUid()
          }
        })
      }
      native.close()
    },
    updateTextInfo() {
      const elem = this.$refs.textInput
      elem.style.height = 'auto'
      elem.style.height = elem.scrollHeight + 'px'
      elem.scrollTop = elem.scrollHeight
      if (this.msgTxt.length > MAX_INPUT_NUM) {
        this.msgTxt = this.msgTxt.substring(0, MAX_INPUT_NUM)
      }
    },
    txtBoxBlur() {
      setTimeout(() => {
        window.scrollTo(0, window.pageYOffset)
      }, 100)
    },
    confirmSubmit() {
      if (this.msgTxt.length < 5) {
        toast({
          msg: '请至少输入5个字',
          style: '2'
        })
        return
      }
      const { appType, orderId, subConvId, ticketId } = this.urlParams
      let fileUrl = ''
      if (this.files.length) { // 有上传文件
        const isError = this.files.some(item => item.status === 'error')
        const isLoading = this.files.some(item => item.status === 'uploading')
        if (isError) { // 如果有错误的--上传失败的情况，则拦截提交
          toast({
            msg: '上传失败，请重新上传',
            style: '2'
          })
          return
        } else if (isLoading) { // 如果有正在上传中的情况，则给予提示拦截提交
          toast({
            msg: '正在上传中，请稍等',
            style: '2'
          })
          return
        } else { // 其他正常的情况
          // 拼接后端需要的数据结构
          // const reg = new RegExp(/(?<=zhuanzh\/)[\s\S]*/)
          fileUrl = this.files.map((item) => {
            // const name = item.url.match(reg)
            const name = item.url.split('zhuanzh/')[1]
            return `${name}|${item.url}`
          })

          // 存在上传成功但文件处理服务返回的数据有问题的情况
          const flag = fileUrl.some((file) => {
            return file.includes('undefined')
          })

          if (flag) {
            toast({
              msg: '图片上传异常，请您删除后重新上传',
              style: '2'
            })

            return
          }
        }
      }
      const params = {
        ticketId,
        operatorUid: getCookie('uid'),
        operatorName: getCookie('nickname') || '',
        remark: fileUrl.length ? `${this.msgTxt}~|${JSON.stringify(fileUrl)}` : this.msgTxt
      }
      userLeavingMessage(params).then((resp) => {
        if (resp) {
          if (resp.status && +resp.status === 1907) {
            toast({
              msg: '留言成功',
              style: '1'
            })
            if (subConvId && ticketId) { // 有子会话id表示从IM进入，则需要记录成功留言
              lego.send({
                pagetype: 'SERVICE_LEAVE_MESSAGE',
                actiontype: 'LEAVE_MSG_SUCCESS',
                backup: {
                  appType,
                  orderId,
                  subConvId,
                  ticketId,
                  sendTime: new Date().getTime()
                }
              })
            }
            setTimeout(() => {
              native.close()
            }, 1500)
            return
          } else if (resp.status && +resp.status === 0) {
            toast({
              msg: resp.msg || '今日留言过多，请明天再来吧',
              style: '1'
            })
            return
          }
        }
        toast({
          msg: '留言失败',
          style: '2'
        })
      })
    }
  }
}
</script>

<style lang="less">
  @import './index.less';
</style>
